import styled, { css } from "styled-components";

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: var(--color-secondary);

  display: flex;
  align-items: center;
  gap: 1rem;

  min-width: fit-content;

  ${(props) =>
    props.centered &&
    css`
      justify-content: center;
    `}
`;

const Subtitle = styled.span`
  font-size: 1.5rem;
  font-weight: 300;

  color: var(--color-text-secondary);
`;

const Text = styled.span`
  font-size: 1rem;

  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.justify &&
    css`
      text-align: justify;
    `}

  color: var(--color-text-secondary);
`;

export { Title, Subtitle, Text };
